import { cva } from 'class-variance-authority';

/** Day cell button for range calendar (CVA with range-aware state variants). */
export const rangeDayCellClasses = cva(
  [
    'tw:flex tw:items-center tw:justify-center',
    'tw:w-full tw:aspect-square',
    'tw:text-14 tw:font-regular',
    'tw:transition-colors tw:duration-150',
    'tw:border-0 tw:p-0',
    'tw:focus:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-primary tw:focus-visible:ring-inset',
  ].join(' '),
  {
    variants: {
      state: {
        default:
          'tw:text-font tw:bg-white tw:cursor-pointer tw:hover:bg-gray-lighter tw:rounded-[var(--radius-8)]',
        today:
          'tw:text-accent tw:font-semibold tw:bg-white tw:cursor-pointer tw:hover:bg-gray-lighter tw:rounded-[var(--radius-8)]',
        selected:
          'tw:bg-primary tw:text-white tw:font-semibold tw:cursor-pointer tw:rounded-[var(--radius-8)]',
        rangeStart:
          'tw:bg-primary tw:text-white tw:font-semibold tw:cursor-pointer tw:rounded-l-[var(--radius-8)] tw:rounded-r-0',
        rangeEnd:
          'tw:bg-primary tw:text-white tw:font-semibold tw:cursor-pointer tw:rounded-r-[var(--radius-8)] tw:rounded-l-0',
        inRange:
          'tw:bg-primary-light tw:text-font tw:cursor-pointer tw:rounded-0 tw:hover:bg-primary/30',
        disabled: 'tw:text-gray tw:opacity-50 tw:cursor-not-allowed tw:rounded-[var(--radius-8)]',
        adjacent:
          'tw:text-gray-dark tw:bg-white tw:cursor-pointer tw:hover:bg-gray-lighter tw:rounded-[var(--radius-8)]',
      },
    },
    defaultVariants: {
      state: 'default',
    },
  }
);
